module.exports = __webpack_public_path__ + "img/our-world-logo-colour.3414de82.png";